// DO NOT EDIT -- generated from fs/services/alexa/search_service.proto

import { CompletionGroup } from './fieldsuggest.proto';
import { ComputeDimensionsRequest, ComputeDimensionsResponse, ComputeScrollMapsStatsRequest, ComputeScrollMapsStatsResponse, CountDocsRequest, CountDocsResponse, CountResponse, DailyActivesThresholdRequest, FetchSessionMarkersRequest, FetchSessionMarkersResponse, GenerateOpportunitiesRequest, GenerateOpportunitiesResponse, GenerateSearchieRequestProto, GenerateSearchieResponseProto, GenerateSignalsRequest, GenerateSignalsResponse, GetIndividualRequest, GetIndividualResponse, ListEventsRequest, ListEventsResponse, ListIndividualsRequest, ListIndividualsResponse, QueryRequest, QueryResponse, SearchPreviewsRequest, SearchPreviewsResponse, SearchSessionsRequest, SearchSessionsResponse } from './search_service_types.proto';
import { ApiError } from './searchies.proto';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as suggest from './suggest';

/**
 * TODO(clay): Move req / resp proto messages to Alexa.
 * TODO(jb): Remove `GenerateOpportunities`,
 *  `ComputeDimensions`, and `GenerateSignals` after SearchServicePublic has been wired and deployed
 */
export namespace SearchService {

  export const QueryEndpoint = "/grpc/alexa.SearchService/Query";
  /**
   * Query executes the supplied Solr JSON request and returns the
   * Solr JSON response.
   */
  export function Query(sender: (req: QueryRequest, endpoint: string) => Promise<QueryResponse>, req: QueryRequest): { promise: () => Promise<QueryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, QueryEndpoint),
      endpoint: QueryEndpoint
    };
  }

  export const DailyActivesThresholdEndpoint = "/grpc/alexa.SearchService/DailyActivesThreshold";
  /**
   * DailyActivesThreshold returns the indv count for the daily actives
   * searchie, suitable for a trendline alert.
   */
  export function DailyActivesThreshold(sender: (req: DailyActivesThresholdRequest, endpoint: string) => Promise<CountResponse>, req: DailyActivesThresholdRequest): { promise: () => Promise<CountResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DailyActivesThresholdEndpoint),
      endpoint: DailyActivesThresholdEndpoint
    };
  }

  export const GenerateSearchieEndpoint = "/grpc/alexa.SearchService/GenerateSearchie";
  /**
   * GenerateSearchie returns searchie data for the requested searchie type and search criteria.
   * As long as a valid searchie type and existing org is provided, no errors are expected.
   * Expected error codes:
   *   NotFound: If Org is not found.
   *   InvalidArgument: If a searchie can't be generated due to insufficient parameters.
   */
  export function GenerateSearchie(sender: (req: GenerateSearchieRequestProto, endpoint: string) => Promise<GenerateSearchieResponseProto>, req: GenerateSearchieRequestProto): { promise: () => Promise<GenerateSearchieResponseProto>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateSearchieEndpoint),
      endpoint: GenerateSearchieEndpoint
    };
  }

  export const SearchPreviewsEndpoint = "/grpc/alexa.SearchService/SearchPreviews";
  /**
   * SearchPreviews returns minimal data required to render a preview.
   * The results are roughly the most recent options available to preview an event.
   * Results will contain at most one preview for a given individual, preferring cross individual results.
   */
  export function SearchPreviews(sender: (req: SearchPreviewsRequest, endpoint: string) => Promise<SearchPreviewsResponse>, req: SearchPreviewsRequest): { promise: () => Promise<SearchPreviewsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SearchPreviewsEndpoint),
      endpoint: SearchPreviewsEndpoint
    };
  }

  export const SearchSessionsEndpoint = "/grpc/alexa.SearchService/SearchSessions";
  /**
   * SearchSessions returns sessions or clips collected using the provided search parameters.
   * Results will always be contained under a single individual.
   * If an IndvId is not provided, an arbitrary matching individual will be found and used to generate sessions / clips.
   * Expected error codes:
   *   InvalidArgument: If invalid criteria is provided.
   */
  export function SearchSessions(sender: (req: SearchSessionsRequest, endpoint: string) => Promise<SearchSessionsResponse>, req: SearchSessionsRequest): { promise: () => Promise<SearchSessionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SearchSessionsEndpoint),
      endpoint: SearchSessionsEndpoint
    };
  }

  export const FetchSessionMarkersEndpoint = "/grpc/alexa.SearchService/FetchSessionMarkers";
  /**
   * FetchSessionMarkers returns the clip markers for a particular session if the search criteria include 1 SEF.
   * Expected error codes:
   *   InvalidArgument: If invalid criteria is provided.
   */
  export function FetchSessionMarkers(sender: (req: FetchSessionMarkersRequest, endpoint: string) => Promise<FetchSessionMarkersResponse>, req: FetchSessionMarkersRequest): { promise: () => Promise<FetchSessionMarkersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FetchSessionMarkersEndpoint),
      endpoint: FetchSessionMarkersEndpoint
    };
  }

  export const GenerateSignalsEndpoint = "/grpc/alexa.SearchService/GenerateSignals";
  /**
   * GenerateSignals returns a list of Signal that can be used to find Opportunities for a given conversion funnel
   * and cohort. A Signal is defined as an event or a property that can be experienced or is a property of a user.
   */
  export function GenerateSignals(sender: (req: GenerateSignalsRequest, endpoint: string) => Promise<GenerateSignalsResponse>, req: GenerateSignalsRequest): { promise: () => Promise<GenerateSignalsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateSignalsEndpoint),
      endpoint: GenerateSignalsEndpoint
    };
  }

  export const CountDocsEndpoint = "/grpc/alexa.SearchService/CountDocs";
  /**
   * CountDocs counts the number of documents created in a given time range
   * (or for all time, if timeRange.Start and timeRange.End == "").
   * It guarantees that all docs will be counted (i.e. won't return partial counts) and thus may
   * have reduced availability during partial search outages.
   */
  export function CountDocs(sender: (req: CountDocsRequest, endpoint: string) => Promise<CountDocsResponse>, req: CountDocsRequest): { promise: () => Promise<CountDocsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CountDocsEndpoint),
      endpoint: CountDocsEndpoint
    };
  }

  export const GetIndividualEndpoint = "/grpc/alexa.SearchService/GetIndividual";
  /**
   * GetIndividual returns the individual for the provided request.
   * Expected error codes:
   *   NotFound: If the individual or org is not found.
   */
  export function GetIndividual(sender: (req: GetIndividualRequest, endpoint: string) => Promise<GetIndividualResponse>, req: GetIndividualRequest): { promise: () => Promise<GetIndividualResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIndividualEndpoint),
      endpoint: GetIndividualEndpoint
    };
  }

  export const ComputeScrollMapsStatsEndpoint = "/grpc/alexa.SearchService/ComputeScrollMapsStats";
  /** ComputeScrollMapsStats returns a distribution of how many users scrolled down a given percentage depth of the page. */
  export function ComputeScrollMapsStats(sender: (req: ComputeScrollMapsStatsRequest, endpoint: string) => Promise<ComputeScrollMapsStatsResponse>, req: ComputeScrollMapsStatsRequest): { promise: () => Promise<ComputeScrollMapsStatsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeScrollMapsStatsEndpoint),
      endpoint: ComputeScrollMapsStatsEndpoint
    };
  }

  export const GenerateOpportunitiesEndpoint = "/grpc/alexa.SearchService/GenerateOpportunities";
  /**
   * GenerateOpportunities returns opportunities for the supplied signals and conversion params.
   * Opportunity includes the conversion stats, when users experience a particular signal.
   */
  export function GenerateOpportunities(sender: (req: GenerateOpportunitiesRequest, endpoint: string) => Promise<GenerateOpportunitiesResponse>, req: GenerateOpportunitiesRequest): { promise: () => Promise<GenerateOpportunitiesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateOpportunitiesEndpoint),
      endpoint: GenerateOpportunitiesEndpoint
    };
  }

  export const ComputeDimensionsEndpoint = "/grpc/alexa.SearchService/ComputeDimensions";
  /**
   * ComputeDimensions returns the Dimension data (Browser,Device,etc.) for the supplied signal and conversion params.
   * Returns a ComputeDimensionsResponse which contains an array of Dimensions.
   */
  export function ComputeDimensions(sender: (req: ComputeDimensionsRequest, endpoint: string) => Promise<ComputeDimensionsResponse>, req: ComputeDimensionsRequest): { promise: () => Promise<ComputeDimensionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeDimensionsEndpoint),
      endpoint: ComputeDimensionsEndpoint
    };
  }

  export const ListIndividualsEndpoint = "/grpc/alexa.SearchService/ListIndividuals";
  /** ListIndividuals returns individual data (primarily IDs) for all of the individuals in solr. */
  export function ListIndividuals(sender: (req: ListIndividualsRequest, endpoint: string) => Promise<ListIndividualsResponse>, req: ListIndividualsRequest): { promise: () => Promise<ListIndividualsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListIndividualsEndpoint),
      endpoint: ListIndividualsEndpoint
    };
  }

  export const ListEventsEndpoint = "/grpc/alexa.SearchService/ListEvents";
  export function ListEvents(sender: (req: ListEventsRequest, endpoint: string) => Promise<ListEventsResponse>, req: ListEventsRequest): { promise: () => Promise<ListEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListEventsEndpoint),
      endpoint: ListEventsEndpoint
    };
  }
}

export namespace SearchServicePublic {

  export const OmniSuggestEndpoint = "/grpc/alexa.SearchServicePublic/OmniSuggest";
  /**
   * OmniSuggest takes a search term and returns relevant suggestions for Omnibox (all fields).
   * Expected error codes:
   *   NotFound: If Org is not found.
   *   InvalidArgument: If autosuggestion cannot take place due to invalid parameters.
   */
  export function OmniSuggest(sender: (req: OmniSuggestRequest, endpoint: string) => Promise<OmniSuggestResponse>, req: OmniSuggestRequest): { promise: () => Promise<OmniSuggestResponse>, endpoint: string } {
    return {
      promise: () => sender(req, OmniSuggestEndpoint),
      endpoint: OmniSuggestEndpoint
    };
  }

  export const FieldSuggestEndpoint = "/grpc/alexa.SearchServicePublic/FieldSuggest";
  /** FieldSuggest takes a search term and relevant context and returns text completion results for a specific field. */
  export function FieldSuggest(sender: (req: FieldSuggestRequest, endpoint: string) => Promise<FieldSuggestResponse>, req: FieldSuggestRequest): { promise: () => Promise<FieldSuggestResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FieldSuggestEndpoint),
      endpoint: FieldSuggestEndpoint
    };
  }

  export const GenerateOpportunitiesEndpoint = "/grpc/alexa.SearchServicePublic/GenerateOpportunities";
  /**
   * GenerateOpportunities returns opportunities for the supplied signals and conversion params.
   * Opportunity includes the conversion stats, when users experience a particular signal.
   */
  export function GenerateOpportunities(sender: (req: GenerateOpportunitiesRequest, endpoint: string) => Promise<GenerateOpportunitiesResponse>, req: GenerateOpportunitiesRequest): { promise: () => Promise<GenerateOpportunitiesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateOpportunitiesEndpoint),
      endpoint: GenerateOpportunitiesEndpoint
    };
  }

  export const ComputeDimensionsEndpoint = "/grpc/alexa.SearchServicePublic/ComputeDimensions";
  /**
   * ComputeDimensions returns the Dimension data (Browser,Device,etc.) for the supplied signal and conversion params.
   * Returns a ComputeDimensionsResponse which contains an array of Dimensions.
   */
  export function ComputeDimensions(sender: (req: ComputeDimensionsRequest, endpoint: string) => Promise<ComputeDimensionsResponse>, req: ComputeDimensionsRequest): { promise: () => Promise<ComputeDimensionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeDimensionsEndpoint),
      endpoint: ComputeDimensionsEndpoint
    };
  }

  export const GenerateSignalsEndpoint = "/grpc/alexa.SearchServicePublic/GenerateSignals";
  /**
   * GenerateSignals returns a list of Signal that can be used to find Opportunities for a given conversion funnel
   * and cohort. A Signal is defined as an event or a property that can be experienced or is a property of a user.
   */
  export function GenerateSignals(sender: (req: GenerateSignalsRequest, endpoint: string) => Promise<GenerateSignalsResponse>, req: GenerateSignalsRequest): { promise: () => Promise<GenerateSignalsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateSignalsEndpoint),
      endpoint: GenerateSignalsEndpoint
    };
  }

  export const GetAPIErrorsEndpoint = "/grpc/alexa.SearchServicePublic/GetAPIErrors";
  /** GetAPIErrors returns a summary of the FullStory client API errors for the provided time range. */
  export function GetAPIErrors(sender: (req: GetAPIErrorsRequest, endpoint: string) => Promise<GetAPIErrorsResponse>, req: GetAPIErrorsRequest): { promise: () => Promise<GetAPIErrorsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAPIErrorsEndpoint),
      endpoint: GetAPIErrorsEndpoint
    };
  }

  export const SearchPreviewsEndpoint = "/grpc/alexa.SearchServicePublic/SearchPreviews";
  /**
   * SearchPreviews returns minimal data required to render a preview.
   * The results are roughly the most recent options available to preview an event.
   * Results will contain at most one preview for a given individual, preferring cross individual results.
   */
  export function SearchPreviews(sender: (req: SearchPreviewsRequest, endpoint: string) => Promise<SearchPreviewsResponse>, req: SearchPreviewsRequest): { promise: () => Promise<SearchPreviewsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SearchPreviewsEndpoint),
      endpoint: SearchPreviewsEndpoint
    };
  }

  export const SearchSessionsEndpoint = "/grpc/alexa.SearchServicePublic/SearchSessions";
  /**
   * SearchSessions returns sessions or clips collected using the provided search parameters.
   * Results will always be contained under a single individual.
   * If an IndvId is not provided, an arbitrary matching individual will be found and used to generate sessions / clips.
   * Expected error codes:
   *   InvalidArgument: If invalid criteria is provided.
   */
  export function SearchSessions(sender: (req: SearchSessionsRequest, endpoint: string) => Promise<SearchSessionsResponse>, req: SearchSessionsRequest): { promise: () => Promise<SearchSessionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SearchSessionsEndpoint),
      endpoint: SearchSessionsEndpoint
    };
  }

  export const FetchSessionMarkersEndpoint = "/grpc/alexa.SearchServicePublic/FetchSessionMarkers";
  /**
   * FetchSessionMarkers returns the clip markers for a particular session if the search criteria include 1 SEF.
   * Expected error codes:
   *   InvalidArgument: If invalid criteria is provided.
   */
  export function FetchSessionMarkers(sender: (req: FetchSessionMarkersRequest, endpoint: string) => Promise<FetchSessionMarkersResponse>, req: FetchSessionMarkersRequest): { promise: () => Promise<FetchSessionMarkersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FetchSessionMarkersEndpoint),
      endpoint: FetchSessionMarkersEndpoint
    };
  }

  export const ComputeScrollMapsStatsEndpoint = "/grpc/alexa.SearchServicePublic/ComputeScrollMapsStats";
  /** ComputeScrollMapsStats returns a distribution of how many users scrolled down a given percentage depth of the page. */
  export function ComputeScrollMapsStats(sender: (req: ComputeScrollMapsStatsRequest, endpoint: string) => Promise<ComputeScrollMapsStatsResponse>, req: ComputeScrollMapsStatsRequest): { promise: () => Promise<ComputeScrollMapsStatsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeScrollMapsStatsEndpoint),
      endpoint: ComputeScrollMapsStatsEndpoint
    };
  }

  export const GenerateSearchieEndpoint = "/grpc/alexa.SearchServicePublic/GenerateSearchie";
  /**
   * GenerateSearchie returns searchie data for the requested searchie type and search criteria.
   * As long as a valid searchie type and existing org is provided, no errors are expected.
   * Expected error codes:
   *   NotFound: If Org is not found.
   *   InvalidArgument: If a searchie can't be generated due to insufficient parameters.
   */
  export function GenerateSearchie(sender: (req: GenerateSearchieRequestProto, endpoint: string) => Promise<GenerateSearchieResponseProto>, req: GenerateSearchieRequestProto): { promise: () => Promise<GenerateSearchieResponseProto>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateSearchieEndpoint),
      endpoint: GenerateSearchieEndpoint
    };
  }

  export const ListEventsEndpoint = "/grpc/alexa.SearchServicePublic/ListEvents";
  export function ListEvents(sender: (req: ListEventsRequest, endpoint: string) => Promise<ListEventsResponse>, req: ListEventsRequest): { promise: () => Promise<ListEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListEventsEndpoint),
      endpoint: ListEventsEndpoint
    };
  }
}

export namespace SearchServiceAdmin {

  export const SetDeletionWatermarkEndpoint = "/grpc/alexa.SearchServiceAdmin/SetDeletionWatermark";
  /**
   * SetDeletionWatermark updates the deletion watermark for an org. The
   * watermarks are used to discard entries in the query cache. If the
   * supplied watermark timestamp is <= a previously recorded watermark, no
   * changes are made.
   */
  export function SetDeletionWatermark(sender: (req: DeletionWatermarkRequest, endpoint: string) => Promise<{}>, req: DeletionWatermarkRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetDeletionWatermarkEndpoint),
      endpoint: SetDeletionWatermarkEndpoint
    };
  }
}

/** DeletionKind represents the kinds of deletions. */
export enum DeletionKind {
  /**
   * Bitfield: values must be powers of 2.
   * If you update this, you may also want to update the constant
   * DeletionKind_ALL.
   */
  NONE = 0,
  /** bulk deletion (e.g. time range deletion, segment deletion) */
  BULK = 1,
  /** indv deletion (e.g. DeleteIndividual) */
  INDV = 2
}

export interface DeletionWatermarkRequest {
  orgId: string;
  /** The kind of deletion. */
  deletionKind: DeletionKind;
  /** The new deletion watermark for the deletion kind. */
  watermark: protobuf.timestamp | null;
}

export interface OmniSuggestRequest {
  /** The org ID for which the suggestions will be provided. */
  orgId: string;
  /** The current search term. */
  term: string;
  /** Optional. Used to specify that autosuggest group when only a single group is needed. */
  groupType: suggest.SuggestionGroupType;
  /** Optional. Determines which kinds of suggestions are returned. */
  context: suggest.SuggestionContext;
  userContextDetails?: {} | null;
  eventContextDetails?: {} | null;
  /** The event filter for dependent event contexts. */
  dependentEventContextDetails?: OmniSuggestRequest.DependentEventContextDetails | null;
  exactPathEnabled: boolean;
  /**
   * Optional. If set, results whose last seen time is before this timestamp will be ignored.
   * This could result in no values for a prefix whose top K results are old but further refinement could still yield suggestions.
   */
  ignoreBefore: protobuf.timestamp | null;
}

export namespace OmniSuggestRequest {
  export enum context_details {
    userContextDetails = 5,
    eventContextDetails = 6,
    /** The event filter for dependent event contexts. */
    dependentEventContextDetails = 7
  }

  export function context_details_oneof(m: OmniSuggestRequest): { opt: context_details.dependentEventContextDetails, val: OmniSuggestRequest.DependentEventContextDetails } | { opt: context_details.eventContextDetails, val: {} } | { opt: context_details.userContextDetails, val: {} } | null {
    if (m.userContextDetails != null) { return { opt: context_details.userContextDetails, val: m.userContextDetails } }
    if (m.eventContextDetails != null) { return { opt: context_details.eventContextDetails, val: m.eventContextDetails } }
    if (m.dependentEventContextDetails != null) { return { opt: context_details.dependentEventContextDetails, val: m.dependentEventContextDetails } }
    return null;
  }

  export interface DependentEventContextDetails {
    eventFilter: segment.EventFilter | null;
  }
}

export interface OmniSuggestResponse {
  groups: suggest.SuggestionGroup[];
}

export interface FieldSuggestRequest {
  /** The org ID for which the autocomplete results will be supplied. */
  orgId: string;
  userFilter?: segment.UserFilter | null;
  eventFilter?: segment.EventFilter | null;
  dependentEventFilter?: FieldSuggestRequest.DependentEventFilter | null;
  /** The search term to use for autocompletion. */
  term: string;
  /**
   * Optional. If set, results whose last seen time is before this timestamp will be ignored.
   * This could result in no values for a prefix whose top K results are old but further refinement could still yield suggestions.
   */
  ignoreBefore: protobuf.timestamp | null;
}

export namespace FieldSuggestRequest {
  export enum filter {
    userFilter = 8,
    eventFilter = 9,
    dependentEventFilter = 10
  }

  export function filter_oneof(m: FieldSuggestRequest): { opt: filter.dependentEventFilter, val: FieldSuggestRequest.DependentEventFilter } | { opt: filter.eventFilter, val: segment.EventFilter } | { opt: filter.userFilter, val: segment.UserFilter } | null {
    if (m.userFilter != null) { return { opt: filter.userFilter, val: m.userFilter } }
    if (m.eventFilter != null) { return { opt: filter.eventFilter, val: m.eventFilter } }
    if (m.dependentEventFilter != null) { return { opt: filter.dependentEventFilter, val: m.dependentEventFilter } }
    return null;
  }

  export interface DependentEventFilter {
    dependentEventFilter: segment.DependentEventFilter | null;
    /** event filter is used since some dependent suggestions are contextual with regards to the main event filter */
    eventFilter: segment.EventFilter | null;
  }
}

export interface FieldSuggestResponse {
  /** Completion groups resulting from the search term and related context. */
  completionGroups: CompletionGroup[];
}

export interface GetAPIErrorsRequest {
  orgId: string;
  timeRange: segment.TimeRange | null;
}

export interface GetAPIErrorsResponse {
  /** Errors for the `FS('trackEvent')` API. */
  event: GetAPIErrorsResponse.APIErrors | null;
  /** Errors for the `FS('setIdentity')` API. */
  user: GetAPIErrorsResponse.APIErrors | null;
  /** Errors for the `FS('setProperties', { type: 'page' })` API. */
  page: GetAPIErrorsResponse.APIErrors | null;
  /** Errors for the element properties API. */
  element: GetAPIErrorsResponse.APIErrors | null;
  /** Errors for watched elements. */
  seen: GetAPIErrorsResponse.APIErrors | null;
}

export namespace GetAPIErrorsResponse {
  export interface APIErrors {
    /** All relevant errors. */
    errors: ApiError[];
    /** The number of times that the associated API call was rate limited. */
    rateLimitCount: protobuf.int64;
    /** The number of times that the associated API call was limited based on the cardinality of the properties. */
    propertyCardinalityLimitCount: protobuf.int64;
    /**
     * The number of times that the associated API call was limited based on the cardinality of the name.
     * Currently only applies to the event API (i.e. Custom event names).
     */
    nameCardinalityLimitCount: protobuf.int64;
  }
}
